import script from "./AuthScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthScreen.vue?vue&type=script&setup=true&lang=ts"

import "./AuthScreen.vue?vue&type=style&index=0&id=1f8d2abf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8d2abf"]])

export default __exports__